var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('create-doc',{attrs:{"title":"source-page","attributes":_vm.attributes,"examples":_vm.examples,"events":_vm.events}})}
var staticRenderFns = []

export { render, staticRenderFns }